import React, { useState, useEffect } from "react";
import PickUpStationForm from "./PickUpStationForm";
import { Column, Row } from "simple-flexbox";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../../../utilities/useTable";
import { ToastContainer } from "react-toastify";
import StatComponent from "../../stat-page/StatComponent";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Popup from "../../../utilities/Popup";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CloseIcon from "@material-ui/icons/Close";
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddPickUpStationForm from "./AddPickUpStationForm";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(5),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "openingTime", label: "Address" },
  { id: "closingTime", label: "Opening Time" },
  { id: "city", label: "Closing Time" },
  { id: "state", label: "State" },
  { id: "state", label: "City" },
  { id: "actions", label: "Actions", disableSorting: true },
];

export function PickUpStation({
  pickUpStations,
  cities,
  allCities,
  allStates,
  states,
  countries,
  UpdatePickUpStation,
  LoadPickUpStations,
  AddPickUpStation,
  DeletePickUpStation,
}) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: "", type: "" });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable((pickUpStations), headCells, filterFn);

  useEffect(() => {
    LoadPickUpStations(localStorage.getItem("companyId"));
    return () => { };
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.cityName.toLowerCase().includes(target.value)
          );
      },
    });
  };

  const addOrEdit = (PickUpStation, resetForm) => {
    if (PickUpStation.id === 0) AddPickUpStation(PickUpStation);
    else
      var data = {
        ...PickUpStation,
        companyId: localStorage.getItem("companyId"),
      };
    UpdatePickUpStation(data);
    resetForm();
    // setRecordForEdit(null)
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const addPickUpStation = (PickUpStation, resetForm) => {
    AddPickUpStation(PickUpStation);
    resetForm();
    setRecordForEdit(null);
    setAddOpenPopup(false);
    setOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };

  const onDelete = (id) => {
    DeletePickUpStation(id);
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };
  return (
    <div>
      <Column>
        <ToastContainer />
        <div className="w-11/12 -mb-5 ml-10">
          <Controls.Input
            placeholder="Search City by City Name"
            className={classes.searchInput}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={handleSearch}
          />
        </div>
        <Paper className={classes.pageContent}>
          <h5><strong>PickUp Station(s)</strong></h5>
          <Toolbar>
            <Controls.Button
              text="Add New"
              variant="outlined"
              startIcon={<AddIcon />}
              className={classes.newButton}
              onClick={() => {
                setAddOpenPopup(true);
                setRecordForEdit(null);
              }}
            />
          </Toolbar>
          <TblContainer>
            <TblHead />
            <TableBody>
              {recordsAfterPagingAndSorting().map(item =>
              (<TableRow key={item.pickUpStationId}>
                <TableCell>{item.pickUpStationAddress}</TableCell>
                <TableCell>{item.openingTime}</TableCell>
                <TableCell>{item.closingTime}</TableCell>
                <TableCell>{item.cityName}</TableCell>
                <TableCell>{item.stateName}</TableCell>
                <TableCell>
                  <Controls.ActionButton
                    color="primary"
                    onClick={() => {
                      openInPopup(item);
                    }}
                  >
                    <EditOutlinedIcon fontSize="small" />
                  </Controls.ActionButton>
                  <Controls.ActionButton
                    color="secondary"
                    onClick={() => {
                      setConfirmDialog({
                        isOpen: true,
                        title: "Are you sure to delete this record?",
                        subTitle: "You can't undo this operation",
                        onConfirm: () => {
                          onDelete(item.pickUpStationId);
                        },
                      });
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </Controls.ActionButton>
                </TableCell>
              </TableRow>)
              )}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </Paper>
        <Popup
          title="PickUp Station Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <PickUpStationForm
            recordForEdit={recordForEdit}
            addOrEdit={addOrEdit}
            cities={allCities}
            states={allStates}
            countries={countries}
          />
        </Popup>

        <Popup
          title="Add PickUp Station Form "
          openPopup={addOpenPopup}
          setOpenPopup={setAddOpenPopup}
        >
          <AddPickUpStationForm
            recordForEdit={recordForEdit}
            addPickUpStation={addPickUpStation}
            states={states}
            cities={cities}
            countries={countries}
          />
        </Popup>
        <Notification notify={notify} setNotify={setNotify} />
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      </Column>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    buttonloader: state.utilityReducer.buttonloader,
    user: state.userReducer.user,
    cities: state.pickUpStationReducer.cities,
    allCities: state.pickUpStationReducer.allCities,
    allStates: state.pickUpStationReducer.allStates,
    states: state.locationReducer.states,
    countries: state.locationReducer.countries,
    pickUpStations: state.pickUpStationReducer.pickUpStations,
    companyId: state.userReducer.companyId,
  };
}
const mapDispatchToProps = (dispatch) => ({
  UpdatePickUpStation(payload) {
    dispatch({ type: "UPDATE_PICKUPSTATION", payload });
  },

  LoadPickUpStations(payload) {
    dispatch({ type: "LOAD_PICKUPSTATION", payload });
  },
  AddPickUpStation(payload) {
    dispatch({ type: "ADD_PICKUPSTATION", payload });
  },

  DeletePickUpStation(payload) {
    dispatch({ type: "DELETE_PICKUPSTATION", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PickUpStation);
